import React  from "react";
import { Input, Button, Popover, Select } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

import styles from "../../styles/Registers.module.css";
import { Link } from "react-router";

const { Option } = Select;

export const Heading = ({
  type,
  searchValue,
  selectorValue,
  onSearch,
  onCreateRegisterClicked,
  onChangeSelector,
}) => {
  const role = localStorage.getItem("role") 
  return (
    <div className={styles.headingActions}>
      <div className={styles.searchInput}>
        <Input
          placeholder="Pretraži"
          value={searchValue}
          suffix={<SearchOutlined />}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <div>
        <Popover content={role=='N' ? (
          'Zakaži pregled'
        ): (
          'Dodaj izvještaj'
        )} trigger="hover">
          <Link to="/medical-reports/add">
            {" "}
            <Button
              type="primary"
              className={styles.addButton}
              onClick={onCreateRegisterClicked}
            >
              <PlusOutlined />
              Dodaj
            </Button>
          </Link>
        </Popover>
      </div>
    </div>
  );
};
